(function () {
  // Helpers
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const emailOk = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim());
  const phoneOk = (v) => String(v || '').replace(/[^\d+]/g, '').length >= 7;

  // --- debounce (for network friendliness) ---
  function debounce(fn, delay = 300) {
    let t; return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), delay); };
  }

  // --- persist attributes to cart so all gateways receive them ---
  const persistAttributes = debounce(() => {
    const vEmail = document.getElementById('cart-contact-email-visible') || document.getElementById('cart-contact-email');
    const vPhone = document.getElementById('cart-contact-phone-visible') || document.getElementById('cart-contact-phone');
    const vAgree = document.getElementById('cart-privacy-agree-visible') || document.getElementById('cart-privacy-agree');

    const email = vEmail ? vEmail.value : '';
    const phone = vPhone ? vPhone.value : '';
    const agreed = vAgree && vAgree.checked ? 'yes' : 'no';

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        attributes: {
          'Contact Email': email,
          'Contact Phone': phone,
          'Privacy Policy Accepted': agreed
        }
      }),
      keepalive: true
    }).catch(() => {});
  }, 300);

  function setError(input, message) {
    const field = input.closest('.cart-to-checkout-fileds');
    const err = field ? field.querySelector(`.field__error[data-error-for="${input.id}"]`) : null;
    if (err) { err.textContent = message || ''; err.hidden = !message; }
    if (message) input.setAttribute('aria-invalid', 'true');
    else input.removeAttribute('aria-invalid');
  }

  function validatePair(scope) {
    // Prefer the visible (footer) fields; fall back to the hidden sources inside the form
    const email = scope.querySelector('#cart-contact-email-visible') || scope.querySelector('#cart-contact-email');
    const phone = scope.querySelector('#cart-contact-phone-visible') || scope.querySelector('#cart-contact-phone');
    const agree = scope.querySelector('#cart-privacy-agree-visible') || scope.querySelector('#cart-privacy-agree');

    let ok = true;

    if (email) {
      setError(email, '');
      if (!emailOk(email.value)) { setError(email, 'Please enter a valid email.'); ok = false; }
    }
    if (phone) {
      setError(phone, '');
      if (!phoneOk(phone.value)) { setError(phone, 'Please enter a valid phone.'); ok = false; }
    }
    if (agree) {
      setError(agree, '');
      if (!agree.checked) { setError(agree, 'You must accept the privacy policy.'); ok = false; }
    }

    return ok;
  }

  // Keep hidden inputs (inside the <form>) synced for submission
  function syncToHidden(root) {
    const vEmail = root.querySelector('#cart-contact-email-visible');
    const vPhone = root.querySelector('#cart-contact-phone-visible');
    const vAgree = root.querySelector('#cart-privacy-agree-visible');

    const hEmail = document.getElementById('cart-contact-email');
    const hPhone = document.getElementById('cart-contact-phone');
    const hAgree = document.getElementById('cart-privacy-agree');

    if (vEmail && hEmail) hEmail.value = vEmail.value;
    if (vPhone && hPhone) hPhone.value = vPhone.value;
    if (vAgree && hAgree) hAgree.checked = vAgree.checked;
  }

  function setCheckoutEnabled(scope, enabled) {
    const btns = $$(
      '[name="checkout"], button[name="checkout"], a[href*="/checkout"], .shopify-payment-button__button, .shopify-payment-button button',
      scope
    );
    btns.forEach((b) => {
      if (enabled) {
        b.removeAttribute('disabled');
        b.classList.remove('disabled');
        b.setAttribute('aria-disabled', 'false');
      } else {
        b.setAttribute('disabled', 'disabled');
        b.classList.add('disabled');
        b.setAttribute('aria-disabled', 'true');
      }
    });
  }

  function attachToForm(form) {
    if (form.__contactValidationAttached) return;
    form.__contactValidationAttached = true;

    const scope = document; // buttons can be in footer, so operate document-wide

    // Initial state
    setCheckoutEnabled(scope, validatePair(scope));

    // Live validation + syncing + persistence
    [
      '#cart-contact-email-visible',
      '#cart-contact-phone-visible',
      '#cart-privacy-agree-visible',
      '#cart-contact-email',
      '#cart-contact-phone',
      '#cart-privacy-agree'
    ].forEach((sel) => {
      $$(sel, scope).forEach((el) => {
        const handler = () => {
          if (el.id.includes('visible')) syncToHidden(scope);
          setCheckoutEnabled(scope, validatePair(scope));
          persistAttributes();
        };
        el.addEventListener('input', handler);
        el.addEventListener('blur', handler);
        el.addEventListener('change', handler); // important for checkbox
      });
    });

    // Hard stop: any submit of the cart form
    form.addEventListener('submit', (evt) => {
      syncToHidden(scope);
      persistAttributes();
      if (!validatePair(scope)) {
        evt.preventDefault();
        evt.stopPropagation();
        setCheckoutEnabled(scope, false);
        const firstInvalid = scope.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus({ preventScroll: false });
      }
    }, true);

    // Extra guard: intercept direct clicks to checkout links/buttons
    $$('[name="checkout"], button[name="checkout"], a[href*="/checkout"]', scope)
      .forEach((btn) => btn.addEventListener('click', (evt) => {
        syncToHidden(scope);
        persistAttributes();
        if (!validatePair(scope)) {
          evt.preventDefault();
          evt.stopPropagation();
          setCheckoutEnabled(scope, false);
        }
      }, true));

    // Save on page exit as last resort
    window.addEventListener('beforeunload', () => persistAttributes());
  }

  function bindAll() {
    $$('form[action="/cart"]').forEach(attachToForm);
  }

  bindAll();

  // Re-bind if cart drawer/page re-renders
  const mo = new MutationObserver(() => bindAll());
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
